import { AutogenModelSalesManager, AutogenRowSalesManager } from "./autogen/AutogenModelSalesManager";

export class ModelSalesManager extends AutogenModelSalesManager<RowSalesManager> {
	constructor() {
		super(RowSalesManager);
	}
}

export class RowSalesManager extends AutogenRowSalesManager {
}